export default __webpack_public_path__ + "images/44e38d89954e473343df071b5954b772.gif";